"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var platform_1 = require("./platform");
var trackEvent = function (props) {
    if (!platform_1.IS_BROWSER || !window.dataLayer)
        return;
    var event = !(props === null || props === void 0 ? void 0 : props.event) ? "customEvent" : props === null || props === void 0 ? void 0 : props.event;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(__assign({ event: event }, props === null || props === void 0 ? void 0 : props.data));
};
exports.default = trackEvent;
//# sourceMappingURL=trackEvent.js.map